module.exports = __webpack_public_path__ + "static/img/serviceprocesswechat.c798266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceprocesswechat.jpg
// module id = 5XIP
// module chunks = 33